export {
  fetchFilters,
  fetchJobs,
  postApply,
  type Job,
  type JobFilter,
  type JobFilters,
  type JobsObject,
} from "./api"
export { cutString } from "./cutString"
export { darkenHex } from "./darkenHex"
export { getCountryItems, type CountryItem } from "./extractCountry"
export { extractImage } from "./extractImage"
export { extractMenuProperties } from "./extractMenuProperties"
export { extractProperty } from "./extractProperty"
export { extractPropertyMediaItems } from "./extractPropertyMediaItems"
export { findProperty } from "./findProperty"
export { schemaCommon } from "./Form/FormSchema"
export { formatTextWithLineBreaks } from "./formatTextWithLineBreaks"
export {
  getAlternateMetadataFromHeader,
  getAlternateMetadataFromPathname,
} from "./getAlternateMetadataFromHeader"
export { getBreadCrumbs } from "./getBreadCrumbs"
export { getLinkHrefFromMultiUrlPickerItem } from "./getLinkHref"
export { getNonUmbracoUrl } from "./getNonUmbracoUrl"
export { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"
export { getUmbracoPDFUrl } from "./getUmbracoPDFUrl"
export { getUmbracoUrl } from "./getUmbracoUrl"
export { handleDownload } from "./handleDownload"
export { replaceMediaUrls } from "./replaceMediaUrls"
export { wrapTables } from "./wrapTables"
export { extractMetaTags } from "./metaTags"
export { type PriorityData } from "./priorityApartments"
export {
  extractFilters,
  extractLandings,
  extractProjectsAndFilters,
  extractSingleProject,
  APARTMENT_TAKEN_STATUS,
  type Apartment,
  type LandingEntity,
  type NumbersObject,
  type ProjectFilter,
  type ProjectFilters,
  type ProjectPage,
} from "./projects"
export { ReactQueryContext } from "./ReactQueryContext"
export {
  extractSearchResults,
  mapAISearchResults,
  type SearchResultItem,
} from "./searchResults"
export { fetchAISearchResults, type AISearchItem, type AISearchResponse } from "./searchApi"
export {
  APPS_WITH_ARRAY_KEYS,
  getSubsidiaryKey,
  SHARED_SUBSIDIARY_KEYS,
  SUBSIDIARY_KEYS,
  type SubsidiaryKey,
} from "./subsidiaryKeyConfig"
export * from "./types"
export { useApi } from "./useApi"
export { useOutsideClick } from "./UseOutsideClick"
export { matchFetchedChildren, type Group, type Groups, type MatchedStatuses } from "./utils"
export { verifyCtaColor } from "./verifyCtaColor"

export {
  aboutUsFilter,
  activeArmsClick,
  articlesClick,
  buttonClick,
  contactButtonClick,
  faqClickClose,
  faqClickOpen,
  filterClick,
  footerMenuClick,
  iconClick,
  jobClick,
  jobFilter,
  jobFormClick,
  jobFormErrorClick,
  jobFormSuccessClick,
  mainMenuClick,
  pageStripClick,
  pageview,
  searchItemClick,
  submitClick,
  submitError,
  submitSuccess,
} from "./gtm"

export { getFavicons, getFaviconsFromPageRoute } from "./getFavicons"

export { getLastPath } from "./getLastUrlPath"

export * from "./redirectsCache"

export * from "./redirectTypes"

export {
  getLandingRedirects,
  getRedirectedProjectSlugs,
  normalizeSubsidiaryKeys,
} from "./landingRedirectsCache"

export * from "./JsonLdSchema"
export * from "./structuredData"

export { useDebouncedCallback } from "./useDebouncer"

export {
  copyColorToClipboard,
  copyUrlToClipboard,
  shareColorNavigator,
  shareUrlNavigator,
} from "./copyToClipboard"

export {
  getColorFromAnchorPosition,
  getScrollPosition,
  scrollToCardById,
  scrollToCardByRef,
} from "./colorScrollerUtils"
export { replaceRichTextLinks } from "./replaceRichTextLinks"

export { extractProductsAndFilters } from "./extractProductsAndFilters"

export { isHTMLString } from "./isHTMLstring"

export { replaceMediaLinksInRichText } from "./replaceMediaLinksInRichText"

export { isDynamicPage } from "./isDynamicPage"

export { isMarketingLandingPage } from "./isMarketingLandingPage"

export { resolveLandingUrl, type ResolvedLandingUrl } from "./resolveLandingUrl"

export {
  ALLOWED_FONTS,
  extractThemeData,
  type AllowedFont,
  type CmsThemeData,
  type ColorPackage,
} from "./extractThemeData"

export { pageHasBlocks } from "./pageHasBlocks"

export { scheduleBmbyMeeting } from "./scheduleBmbyMeeting"

export {
  buildReferralQueryString,
  getReferralSource,
  REFERRAL_QUERY_KEYS,
  REFERRAL_SOURCE_STORAGE_KEY,
  storeReferralSource,
} from "./referral"
export {
  getProjectsPath,
  getSearchPath,
  PROJECTS_PATHS,
  SEARCH_PATHS,
  type AppName,
  type Environment,
} from "./searchConfig"
